
import {catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable  } from 'rxjs';
import { ExceptionService, PaginatedList, UtilsService } from '../../../xform-compat';
import { SecurityIndex } from 'src/app/shared/models/company/security-index.model';


@Injectable({
  providedIn: 'root'
})
export class SecurityIndexService {

  constructor(
    private http: HttpClient,
    private utilsService: UtilsService,
    private exceptionService: ExceptionService
  ) {
  }

  public autocompleteSecurityCompanies (params?: any): Observable<Array<SecurityIndex>> {
    const httpParams: HttpParams = this.utilsService.generateParams(params);
    return this.http
      .get(`/api/rms/security/symbol/autocomplete`, {params: httpParams}).pipe(
      catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

}
